import { useParams } from "react-router-dom";
import { isTaskTakeDebt } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { TakeDebtPage } from "./TakeDebtPage";

const InventoryProducts = () => {
    const { id: marketId, taskId } = useParams();

    const { tasks } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[marketId]?.[taskId];

    if (!currentTask || !isTaskTakeDebt(currentTask)) return <NotFound />;

    return <TakeDebtPage marketId={safeMarketId} task={currentTask} />;
};

export default InventoryProducts;
